export default __webpack_public_path__ + "static/media/fevicon.d4207cc5.png";